import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Checkbox from "@mui/material/Checkbox";
import CssBaseline from "@mui/material/CssBaseline";
import FormControlLabel from "@mui/material/FormControlLabel";
import Divider from "@mui/material/Divider";
import FormLabel from "@mui/material/FormLabel";
import FormControl from "@mui/material/FormControl";
import Link from "@mui/material/Link";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import MuiCard from "@mui/material/Card";
import { styled } from "@mui/material/styles";
import ForgotPassword from "../ForgotPssword";
import AppTheme from "../../shared-theme/AppTheme";
import ColorModeSelect from "../../shared-theme/ColorModeSelect";
import { GoogleIcon, FacebookIcon, SitemarkIcon } from "../CustomIcons";
import logoIcon from "../../assets/images/login-icon.png";
import logoName from "../../assets/images/login-name.png";
import { useNavigate } from "react-router";
import { agentLogin, verifyTwoFactCode } from "../../actions/agent";
import { useSelector, useDispatch } from "react-redux";
import { isAuthenticateTrue, isAuthenticateFalse } from "../../features/auth/authSlice";

const Card = styled(MuiCard)(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
	alignSelf: "center",
	width: "100%",
	padding: theme.spacing(4),
	gap: theme.spacing(2),
	margin: "auto",
	[theme.breakpoints.up("sm")]: {
		maxWidth: "450px",
	},
	boxShadow: "hsla(220, 30%, 5%, 0.05) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.05) 0px 15px 35px -5px",
	...theme.applyStyles("dark", {
		boxShadow: "hsla(220, 30%, 5%, 0.5) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.08) 0px 15px 35px -5px",
	}),
}));

const SignInContainer = styled(Stack)(({ theme }) => ({
	height: "calc((1 - var(--template-frame-height, 0)) * 100dvh)",
	minHeight: "100%",
	padding: theme.spacing(2),
	[theme.breakpoints.up("sm")]: {
		padding: theme.spacing(4),
	},
	"&::before": {
		content: '""',
		display: "block",
		position: "absolute",
		zIndex: -1,
		inset: 0,
		backgroundImage: "radial-gradient(ellipse at 50% 50%, hsl(210, 100%, 97%), hsl(0, 0%, 100%))",
		backgroundRepeat: "no-repeat",
		...theme.applyStyles("dark", {
			backgroundImage: "radial-gradient(at 50% 50%, hsla(210, 100%, 16%, 0.5), hsl(220, 30%, 5%))",
		}),
	},
}));

const Login = (props) => {
	const [passwordError, setPasswordError] = React.useState(false);
	const [passwordErrorMessage, setPasswordErrorMessage] = React.useState("");
	const [pinError, setPinError] = React.useState(false);
	const [pinErrorMessage, setPinErrorMessage] = React.useState("");
	const [open, setOpen] = React.useState(false);
	const [step, setStep] = React.useState(1);
	const { setIsAuthenticated } = props;
	const profile = JSON.parse(localStorage.getItem("profile")) ?? {};
	const { token, id } = profile;
	const dispatch = useDispatch();

	const navigate = useNavigate();

	const handleClickOpen = () => {
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
	};

	const handleSubmit = (event) => {
		event.preventDefault();
		const data = new FormData(event.currentTarget);

		if (data) {
			agentLogin(data.get("username"), data.get("password"), (res) => {
				if (!res.error) {
					if (!res.twoFactorAuth) {
						setIsAuthenticated(true);
						dispatch(isAuthenticateTrue());
						localStorage.setItem("profile", JSON.stringify({ ...res }));
						navigate("/admin");
					} else {
						localStorage.setItem("profile", JSON.stringify({ ...res }));
						dispatch(isAuthenticateFalse());
						setStep(2);
					}
				} else {
					localStorage.setItem("profile", null);
					setPasswordError(true);
					setIsAuthenticated(false);
					setPasswordErrorMessage(res.message);
				}
			});
		}
	};

	const handleSubmitPin = (event) => {
		event.preventDefault();
		const data = new FormData(event.currentTarget);
		if (data) {
			let profile = JSON.parse(localStorage.getItem("profile")) ?? {};
			const { token, id } = profile;
			verifyTwoFactCode(token, data.get("pin"), (res) => {
				if (!res.error) {
					setIsAuthenticated(true);
					dispatch(isAuthenticateTrue());
					navigate("/admin");
				} else {
					localStorage.setItem("profile", null);
					setPinError(true);
					setIsAuthenticated(false);
					dispatch(isAuthenticateFalse());
					setPinErrorMessage(res.message);
				}
			});
		}
	};

	const validateInputs = () => {
		//const username = document.getElementById("username");
		//const password = document.getElementById("password");

		let isValid = true;

		/*if (!password.value || password.value.length < 6) {
			setPasswordError(true);
			setPasswordErrorMessage("Password must be at least 6 characters long.");
			isValid = false;
		} else {
			setPasswordError(false);
			setPasswordErrorMessage("");
		}*/

		//setPasswordError(false);
		//setPasswordErrorMessage("");

		return isValid;
	};

	const validateInputsPin = () => {
		//const username = document.getElementById("username");
		//const password = document.getElementById("password");

		let isValid = true;

		/*if (!password.value || password.value.length < 6) {
			setPasswordError(true);
			setPasswordErrorMessage("Password must be at least 6 characters long.");
			isValid = false;
		} else {
			setPasswordError(false);
			setPasswordErrorMessage("");
		}*/

		//setPasswordError(false);
		//setPasswordErrorMessage("");

		return isValid;
	};

	if (step === 1) {
		return (
			<AppTheme {...props}>
				<CssBaseline enableColorScheme />
				<SignInContainer direction="column" justifyContent="space-between">
					<ColorModeSelect sx={{ position: "fixed", top: "1rem", right: "1rem" }} />
					<Card variant="outlined">
						<Box sx={{ alignContent: "center", alignItems: "center", display: "inline-block" }}>
							<img src={logoIcon} style={{ width: "46px", height: "46px" }}></img>
						</Box>
						<Typography component="h1" variant="h4" sx={{ width: "100%", fontSize: "clamp(2rem, 10vw, 2.15rem)" }}>
							FlashTeller
						</Typography>
						<Box
							component="form"
							onSubmit={handleSubmit}
							noValidate
							sx={{
								display: "flex",
								flexDirection: "column",
								width: "100%",
								gap: 2,
							}}
						>
							<FormControl>
								<FormLabel htmlFor="username">Username</FormLabel>
								<TextField
									id="username"
									type="text"
									name="username"
									placeholder="your username"
									autoFocus
									required
									fullWidth
									variant="outlined"
								/>
							</FormControl>
							<FormControl>
								<FormLabel htmlFor="password">Password</FormLabel>
								<TextField
									error={passwordError}
									helperText={passwordErrorMessage}
									name="password"
									placeholder="••••••"
									type="password"
									id="password"
									autoComplete="current-password"
									required
									fullWidth
									variant="outlined"
									color={passwordError ? "error" : "primary"}
								/>
							</FormControl>
							{/*<FormControlLabel control={<Checkbox value="remember" color="primary" />} label="Remember me" />*/}
							{/*<ForgotPassword open={open} handleClose={handleClose} />*/}
							<Button type="submit" fullWidth variant="contained" onClick={validateInputs}>
								Sign in
							</Button>
						</Box>
					</Card>
				</SignInContainer>
			</AppTheme>
		);
	}

	if (step === 2) {
		return (
			<AppTheme {...props}>
				<CssBaseline enableColorScheme />
				<SignInContainer direction="column" justifyContent="space-between">
					<ColorModeSelect sx={{ position: "fixed", top: "1rem", right: "1rem" }} />
					<Card variant="outlined">
						<Box sx={{ alignContent: "center", alignItems: "center", display: "inline-block" }}>
							<img src={logoIcon} style={{ width: "46px", height: "46px" }}></img>
						</Box>
						<Typography component="h1" variant="h4" sx={{ width: "100%", fontSize: "clamp(2rem, 10vw, 2.15rem)" }}>
							FlashTeller
						</Typography>
						<Box
							component="form"
							onSubmit={handleSubmitPin}
							noValidate
							sx={{
								display: "flex",
								flexDirection: "column",
								width: "100%",
								gap: 2,
							}}
						>
							<FormControl>
								<FormLabel htmlFor="pin">Security Verification</FormLabel>
								<TextField
									error={pinError}
									helperText={pinErrorMessage}
									id="pin"
									type="number"
									name="pin"
									placeholder="Authenticador Code"
									autoFocus
									required
									fullWidth
									variant="outlined"
								/>
							</FormControl>
							<Typography variant="caption" sx={{ color: "text.secondary" }}>
								{"Enter the 6-digit code from FlashTeller/Google Authenticator"}
							</Typography>
							{/*<FormControlLabel control={<Checkbox value="remember" color="primary" />} label="Remember me" />*/}
							{/*<ForgotPassword open={open} handleClose={handleClose} />*/}
							<Button type="submit" fullWidth variant="contained" onClick={validateInputsPin}>
								Submit
							</Button>
						</Box>
					</Card>
				</SignInContainer>
			</AppTheme>
		);
	}
};

export default Login;
